import { Table, TableColumnsType } from "antd";
import moment from "moment";
import { FC, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getSemesterTests } from "../../../api/semesterTest.api";
import useAxios from "../../../hooks/useAxios";
import { getCommonCodeLabel } from "../../../lib/store";
import { IGetSemesterTests, ISemesterTestItem } from "../../../models/semesterTest.model";
import { SemesterContents } from "../../../pages/program/semester";
import Button from "../../Button";
import ErrorResponse from "../../ErrorResponse";
import Loader from "../../Loader";

interface IProps {
  semesterCode: string;
  setTab: (tab: SemesterContents) => void;
  getTestsTrigger: boolean;
  setScheduleCode: (scheduleCode: number|undefined) => void;
}

const Test: FC<IProps> = ({
  semesterCode,
  setTab,
  getTestsTrigger,
  setScheduleCode,
}) => {
  const { t, i18n } = useTranslation();
  const { data: res, isLoading, error, execute } = useAxios<IGetSemesterTests>();

  const [isFirstRun, setIsFirstRun] = useState(true);

  useEffect(() => {
    if (semesterCode) {
      doGetSemesterTests();
    }
  }, [semesterCode]);

  useEffect(() => {
    if (isFirstRun) {
      setIsFirstRun(false);
      return;
    }
    doGetSemesterTests();
  }, [getTestsTrigger]);

  const doGetSemesterTests = () => {
    if (semesterCode) {
      execute(getSemesterTests(Number(semesterCode)));
    }    
  }

  const renderCreateButton = () => {
    return (
      <div className="comm-btn__area right">
        <Button
          onClick={() => {
            setScheduleCode(undefined);
            setTab(SemesterContents.TestEdit);
          }}
          className="btn-basic pink"
          text={t('program.award.button2')}
        />
      </div>
    );
  }

  const columns: TableColumnsType<ISemesterTestItem> = [
    {
      title: t('common.label.1'),
      dataIndex: 'eduStepCode',
      align: 'center',
      render: value => getCommonCodeLabel('PR0006', value, i18n.language),
    },
    {
      title: t('program.semester.column24'),
      dataIndex: 'examDiv',
      align: 'center',
      render: value => getCommonCodeLabel('TE0001', value, i18n.language),
    },
    {
      title: t('program.semester.column25'),
      dataIndex: 'name',
      align: 'center',
    },
    {
      title: t('program.semester.column22'),
      dataIndex: 'testSeq',
      align: 'center',
    },
    {
      title: t('program.semester.column26'),
      dataIndex: 'srtDate',
      align: 'center',
      render: value => moment(value).format('YYYY.MM.DD'),
    },
    {
      title: t('program.semester.column27'),
      dataIndex: 'endDate',
      align: 'center',
      render: value => moment(value).format('YYYY.MM.DD'),
    },
  ];

  return (
    <>
      {isLoading && <Loader />}
      <ErrorResponse error={error} />

      <div className="comm-bx__space pt-0">
        {renderCreateButton()}
      </div>
      <Table
        className='comm-table__area'
        columns={columns}
        dataSource={res?.data}
        pagination={{
          pageSize: 9999999,
        }}
        onRow={(record) => {
          return {
            onClick: () => {
              setScheduleCode(record.scheduleCode);
              setTab(SemesterContents.TestRead);
            },
          };
        }}
        rowClassName="pointer"
        rowKey="scheduleCode"
      />
      <div className="comm-bx__space border-bottom-light">
        {renderCreateButton()}
      </div>
    </>
  );
}

export default Test;
